<!-- Business Education -->
<template>
  <div class="be-list-page">
    <!-- =========================
         페이지 헤더
    ========================== -->
    <div class="page-header">
      <div class="page-title-area">
        <h2>사업학습</h2>
        <p>사업왕의 성공 노하우를 배우고 나의 사업에 적용해 보세요.</p>
      </div>

      <!-- 매장 선택 -->
      <div v-if="userInfo && userInfo.OGN_FG === '00'" class="shop-selector">
        <div class="selector-item">
          <span class="selector-label">FC</span>

          <select
            v-model="selectedBranch"
            class="branch-select"
            :disabled="userInfo && userInfo.OGN_FG === '01'"
          >
            <option
              v-for="branch in branchList"
              :key="branch.BRANCH_CD"
              :value="branch.BRANCH_CD"
            >
              {{ branch.BRANCH_NM }}
            </option>
          </select>
        </div>

        <div class="selector-item">
          <span class="selector-label">매장</span>

          <input
            list="team-datalist"
            v-model="teamSearch"
            @change="handleTeamSelection"
            class="team-select"
            placeholder="매장 검색 또는 선택"
            :disabled="userInfo && userInfo.OGN_FG === '01'"
          />

          <datalist id="team-datalist">
            <option
              v-for="team in teamList"
              :key="team.SHOP_CD"
              :value="`(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`"
            />
          </datalist>
        </div>
      </div>

      <!-- 사업주 정보 -->
      <div
        v-if="
          userInfo &&
          (userInfo.OGN_FG === '01' ||
            ['TB관리자'].includes(this.userInfo.userId))
        "
        class="owner-info"
      >
        <div class="owner-item">
          <span>점번</span>
          <strong>{{ this.vanBizNo }}</strong>
        </div>

        <div class="owner-item">
          <span>점명</span>
          <strong>{{ this.userInfo.SHOP_NM }}</strong>
        </div>

        <div class="owner-item">
          <span>사업주</span>
          <strong>{{ this.shopMasterNm }}</strong>
        </div>
      </div>
    </div>

    <!-- =========================
         안내 영역
    ========================== -->
    <div class="notice-card">

      <div class="notice-content">
        <strong>사업학습 안내</strong>

        <ul>
          <li>
            공동브랜드 고품격 품질서비스와 브랜드 명성 유지를 위해 사업 성공한
            사업왕에게 사업학습으로 사업주가 성공합니다.
          </li>

          <li>
            3년 이내 같은 사업왕에게 사업학습 하는 경우 사업학습 수수료는
            지급되지 않습니다.
          </li>

          <li>사업주 모두 사업왕에게 배워 사업왕처럼 성공하시길 응원합니다.</li>
        </ul>
      </div>
    </div>

    <!-- =========================
         사업학습 입력
    ========================== -->
    <section class="form-section">
      <div class="section-header">
        <div>
          <h2>{{ currentYear }}년 사업학습</h2>
          <p>월별 사업학습 내용을 입력하고 성공 노하우를 기록해 주세요.</p>
        </div>

        <div class="year-badge">
          {{ currentYear }}
        </div>
      </div>

      <form @submit.prevent="saveData">
        <div class="table-wrapper">
          <table class="plan-table">
            <thead>
              <tr>
                <th class="month-col">{{ currentYear }}년</th>

                <th class="narrow-col">사업왕<br />점포명</th>

                <th class="narrow-col">사업왕<br />성명</th>

                <th class="narrow-col">사업학습<br />일자</th>

                <th class="narrow-col">사업주명</th>

                <th class="narrow-col">사업학습<br />수수료</th>

                <th class="wide-col">
                  사업학습에서<br />
                  느낀점 / 배운점 / 개선할점
                </th>

                <th class="wide-col">
                  전월 사업학습 후<br />
                  개선내용
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(row, index) in planRows" :key="index">
                <!-- 월 -->
                <td class="month-cell">
                  <span>{{ row.month }}</span>
                </td>

                <!-- 사업왕 점포 -->
                <td>
                  <input
                    v-model="row.kingShopNm"
                    class="center-input"
                    placeholder="점포명"
                  />
                </td>

                <!-- 사업왕 성명 -->
                <td>
                  <input
                    v-model="row.kingNm"
                    class="center-input"
                    placeholder="성명"
                  />
                </td>

                <!-- 학습일 -->
                <td>
                  <input
                    type="date"
                    v-model="row.learnDate"
                    :min="row.dateMm + '-01'"
                    :max="row.dateMm + '-' + getLastDay(row.dateMm)"
                    class="date-input"
                  />
                </td>

                <!-- 사업주 -->
                <td>
                  <input
                    v-model="row.ownerNm"
                    class="center-input"
                    placeholder="사업주명"
                  />
                </td>

                <!-- 수수료 -->
                <td>
                  <input
                    v-model="row.eduFee"
                    class="center-input"
                    placeholder="금액"
                  />
                </td>

                <!-- 느낀점 -->
                <td>
                  <textarea
                    v-model="row.learning"
                    class="text-area"
                    placeholder="사업학습에서 느낀점 / 배운점 / 개선할점"
                  ></textarea>
                </td>

                <!-- 개선내용 -->
                <td>
                  <textarea
                    v-model="row.improvement"
                    class="text-area"
                    placeholder="전월 사업학습 후 개선내용"
                  ></textarea>
                </td>

                <!-- 삭제 버튼 -->
                <td>
                  <button 
                    v-if="row.beId && (userInfo && (userInfo.OGN_FG === '01' || ['TB관리자'].includes(this.userInfo.userId)))" 
                    @click="deleteRow(index)"
                    type="button"
                    class="delete-btn">
                    삭제
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 저장 버튼 -->
        <div class="form-footer">
          <div class="save-guide">
            <span class="guide-icon">✓</span>
            매월 사업학습 내용을 기록해 주세요.
          </div>

          <button
            v-if="userInfo && (userInfo.OGN_FG === '01' ||
            ['TB관리자'].includes(this.userInfo.userId))"
            class="save-btn"
            type="submit"
          >
            <span>✓</span>
            저장하기
          </button>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "BusinessEducation",
  data() {
    const currentYear = new Date().getFullYear();
    return {
      selectedBranch: "", // 선택된 본부
      branchList: [],
      selectedTeam: "", // 선택된 팀
      teamList: [], // 팀 목록
      teamSearch: "", // 매장 검색용
      userInfo: null, // 로그인한 사용자 정보

      currentYear,

      vanBizNo: "",
      shopMasterNm: "",
      planRows: [
        {
          month: "1월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-01`,
        },
        {
          month: "2월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-02`,
        },
        {
          month: "3월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-03`,
        },
        {
          month: "4월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-04`,
        },
        {
          month: "5월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-05`,
        },
        {
          month: "6월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-06`,
        },
        {
          month: "7월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-07`,
        },
        {
          month: "8월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-08`,
        },
        {
          month: "9월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-09`,
        },
        {
          month: "10월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-10`,
        },
        {
          month: "11월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-11`,
        },
        {
          month: "12월",
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
          dateMm: `${currentYear}-12`,
        },
      ],
    };
  },

  mounted() {
    // localStorage에서 사용자 정보 불러오기
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    this.fetchCenterList();
    if (this.userInfo?.OGN_FG === "01") {
      // 본부 선택 없이도 바로 팀 목록 불러오기
      this.fetchTeamList("00").then(() => {
        const matched = this.teamList.find(
          (item) => item.SHOP_CD === this.userInfo.SHOP_CD,
        );

        // 찾은 항목이 있으면 그 안의 VAN_BIZ_NO를 formData에 세팅
        if (matched) {
          this.vanBizNo = matched.VAN_BIZ_NO;
        }

        // 사업주명 조회
        this.fetchShopMasterNm(this.userInfo.SHOP_CD);
        // 데이터 조회
        this.loadData(this.userInfo.SHOP_CD);
      });
    }
  },

  watch: {
    selectedBranch(newBranchCd) {
      // 본부가 선택되면 팀 목록을 불러옵니다.
      if (newBranchCd) {
        this.fetchTeamList(newBranchCd).then(() => {
          // 사용자가 직접 본부를 변경했을 때만 매장 선택을 초기화
          if (this.userInfo.OGN_FG === "00") {
            this.selectedTeam = "";
          }
        });
      } else {
        this.teamList = [];
        this.selectedTeam = "";
      }
    },
    selectedTeam(newShopCd) {
      if (newShopCd && newShopCd !== "00") {
        const team = this.teamList.find((t) => t.SHOP_CD === newShopCd);
        if (team) {
          const teamName = `(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`;
          if (this.teamSearch !== teamName) {
            this.teamSearch = teamName;
          }
          if (this.selectedBranch === "전체") {
            this.selectedBranch = team.BRANCH_CD;
          }
          // 선택된 매장으로 랭킹 목록 조회
          // this.fetchShopRankList(newShopCd);
        }
      } else {
        if (this.teamSearch !== "") {
          this.teamSearch = "";
        }
      }
    },
  },

  methods: {
    // 매장 선택(datalist 변경) 처리
    handleTeamSelection() {
      const match = this.teamList.find(
        (t) => `(${t.VAN_BIZ_NO}) ${t.SHOP_NM}` === this.teamSearch,
      );
      if (match) {
        this.selectedTeam = match.SHOP_CD;
        // 매장 코드로 데이터 조회
        this.loadData(this.selectedTeam);
      } else {
        alert("선택한 매장을 찾을 수 없습니다.");
      }
    },

    // 선택한 매장의 랭킹 리스트 가져오기
    async fetchShopRankList(shopCd) {
      try {
        if (!shopCd) {
          this.shopRankList = [];
          return;
        }
        const res = await axios.get("/api/beListPage/fetchShopRanks", {
          params: { shopCd },
        });
        this.shopRankList = Array.isArray(res.data) ? res.data : [];
      } catch (err) {
        console.error("매장 랭킹 로딩 실패:", err);
        this.shopRankList = [];
      }
    },

    async fetchCenterList() {
      try {
        const res = await axios.get("/api/beListPage/centerList");
        this.branchList = res.data;
        if (this.branchList.length > 0) {
          this.selectedBranch = this.branchList[0].BRANCH_CD;
        }
      } catch (error) {
        console.error("본부 목록 로딩 실패:", error);
        alert("본부 목록을 불러오는 데 실패했습니다.");
      }
    },

    async fetchTeamList(branchCd) {
      try {
        const res = await axios.get(
          `/api/beListPage/teamList?branchCd=${branchCd}`,
        );
        this.teamList = res.data;
      } catch (error) {
        console.error("팀 목록 로딩 실패:", error);
        this.teamList = [];
      }
    },

    async fetchShopMasterNm(shopCd) {
      try {
        // 현재 달 YYYY-MM 구하기
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const dateMm = `${year}-${month}`; // 예: 2026-08

        const res = await axios.get("/api/beListPage/storeMaster", {
          params: { shopCd, dateMm },
        });

        if (res.data) {
          this.shopMasterNm = res.data.SHOP_MASTER_NM; // 사업주명 세팅
        }
      } catch (err) {
        console.error("사업주명 조회 실패:", err);
      }
    },

    saveData() {
      if (!this.userInfo || !this.userInfo.SHOP_CD) { alert("매장 정보가 없습니다.\n저장할 수 없습니다."); return; }

      const invalidRows = this.planRows.filter((row) => {
        if (!row.kingShopNm) return false; // kingShopNm 없으면 검사 안함
        // kingShopNm 있으면 나머지 필드 모두 체크
        return !(
          row.kingNm &&
          row.learnDate &&
          row.ownerNm &&
          row.learning
        );
      });

      if (invalidRows.length > 0) {
        const details = invalidRows.map((row) => {
          const missing = [];
          if (!row.kingNm) missing.push("사업왕 성명");
          if (!row.learnDate) missing.push("사업학습 일자");
          if (!row.ownerNm) missing.push("사업주명");
          if (!row.learning) missing.push("사업학습에서 느낀점/배운점/개선할점");
          return `${row.month}: ${missing.join(", ")}`;
        }).join("\n");

        alert(`사업학습 입력값이 모두 채워져야 저장할 수 있습니다.\n누락된 항목:\n${details}`);
        return;
      }
      const payload = this.planRows
        .filter((row) => row.kingShopNm) // kingShopNm 있는 것만 저장
        .map((row) => ({
          shopCd: this.userInfo.SHOP_CD,
          dateMm: `${this.currentYear}${row.month
            .replace("월", "")
            .padStart(2, "0")}`,
          kingShopNm: row.kingShopNm,
          kingNm: row.kingNm,
          learnDate: row.learnDate,
          ownerNm: row.ownerNm,
          eduFee: row.eduFee,
          learning: row.learning,
          improvement: row.improvement,
          userId: this.userInfo.userId,
        }));

      axios
        .post("/api/beListPage/saveEdu", payload)
        .then(() => {
          this.loadData(this.userInfo.SHOP_CD);
          alert("사업학습이 저장되었습니다!");
        })
        .catch((err) => {
          console.error("저장 실패:", err);
          alert("저장 중 오류가 발생했습니다.");
        });
    },
    getLastDay(dateMm) {
      // dateMm: '2026-01' 형식
      if (!dateMm) return "";
      const [year, month] = dateMm.split("-");
      const lastDay = new Date(year, month, 0).getDate(); // 해당 월 마지막 일자 
      return String(lastDay).padStart(2, "0");
    },

    async loadData(shopCd) {
      try {
        const res = await axios.get("/api/beListPage/getEdu", {
          params: { shopCd, year: this.currentYear },
        });

        // 1월~12월 기본 행 생성
        const months = Array.from({ length: 12 }, (_, i) => ({
          month: `${(i + 1).toString().padStart(2, "0")}월`,
          beId: "",
          kingShopNm: "",
          kingNm: "",
          learnDate: "",
          ownerNm: "",
          eduFee: "",
          learning: "",
          improvement: "",
        }));

        // DB 데이터 매핑
        if (res.data && res.data.length > 0) {
          res.data.forEach((row) => {
            const monthIndex = parseInt(row.DATE_MM.slice(4), 10) - 1; // 01~12 → 0~11
            months[monthIndex] = {
              month: row.DATE_MM.slice(4) + "월",
              beId: row.BE_ID,  // 추가
              kingShopNm: row.KING_SHOP_NM || "",
              kingNm: row.KING_NM || "",
              learnDate: row.LEARN_DATE
                ? new Date(row.LEARN_DATE).toISOString().split("T")[0]
                : "",
              ownerNm: row.OWNER_NM || "",
              eduFee: row.EDU_FEE || "",
              learning: row.LEARNING || "",
              improvement: row.IMPROVEMENT || "",
            };
          });
        }

        this.planRows = months; // 최종 세팅
      } catch (err) {
        console.error("조회 실패:", err);
        alert("사업학습 데이터를 불러오는 중 오류가 발생했습니다.");
      }
    },

    deleteRow(index) {
      const beId = this.planRows[index].beId;
      const userId = this.userInfo.userId;

      if (confirm("정말 이 행을 삭제하시겠습니까?")) {
        // 프론트에서 배열에서 제거
        this.planRows.splice(index, 1);

        // 백엔드에도 삭제 요청 (예시: axios 사용)
        axios.post('/api/beListPage/deleteRow', { beId, userId })
          .then(response => {
            console.log("삭제 성공:", response.data);
            this.loadData(this.userInfo.SHOP_CD);
            alert("삭제 성공");
          })
          .catch(error => {
            console.error("삭제 실패:", error);
          });
      }
    },
  },
};
</script>

<style scoped>
/* =========================================================
   전체
========================================================= */

.be-list-page {
  max-height: 100vh;
  padding: 2px;

  background: #f5f7fa;

  box-sizing: border-box;

  font-family: "Malgun Gothic", "Noto Sans KR", Arial, sans-serif;

  color: #1f2937;
}

/* =========================================================
   페이지 헤더
========================================================= */

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 10px;

  margin-bottom: 2px;
  padding: 2px 6px;

  background: #ffffff;

  border: 1px solid #e5e7eb;
  border-radius: 14px;

  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);

  box-sizing: border-box;
}

/* 제목 */

.page-title-area {
  min-width: 210px;
}

.page-title-area h2 {
  margin: 5px 0 0;

  color: #111827;

  font-size: 1.125rem;
  font-weight: 700;

  letter-spacing: -0.5px;
}

.page-title-area p {
  margin: 3px 0 0;

  color: #9ca3af;

  font-size: 12px;
}

/* =========================================================
   매장 선택
========================================================= */

.shop-selector {
  display: flex;
  align-items: center;

  gap: 14px;

  margin-left: auto;
}

.selector-item {
  display: flex;
  align-items: center;

  gap: 7px;
}

.selector-label {
  color: #64748b;

  font-size: 0.8rem;
  font-weight: 600;
}

.branch-select,
.team-select {
  height: 30px;

  padding: 0 10px;

  background: #ffffff;

  border: 1px solid #d1d5db;
  border-radius: 7px;

  outline: none;

  color: #374151;

  font-family: inherit;
  font-size: 0.8rem;

  box-sizing: border-box;

  transition: 0.2s;
}

.branch-select {
  min-width: 110px;
}

.team-select {
  width: 210px;
}

.branch-select:focus,
.team-select:focus {
  border-color: #3b82f6;

  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.branch-select:disabled,
.team-select:disabled {
  background: #f8fafc;
  color: #94a3b8;

  cursor: not-allowed;
}

.team-select::placeholder {
  color: #b6bec9;
}

/* =========================================================
   사업주 정보
========================================================= */

.owner-info {
  display: flex;

  align-items: center;

  gap: 8px;

  margin-left: auto;
}

.owner-item {
  display: flex;
  align-items: center;

  gap: 6px;

  padding: 8px 11px;

  background: #f8fafc;

  border: 1px solid #e5e7eb;

  border-radius: 7px;
}

.owner-item span {
  color: #94a3b8;

  font-size: 0.8rem;
}

.owner-item strong {
  color: #374151;

  font-size: 0.8rem;
}

/* =========================================================
   안내 카드
========================================================= */

.notice-card {
  display: flex;

  gap: 3px;

  padding: 5px 15px;

  background: #ffffff;

  border: 1px solid #e5e7eb;
  border-left: 10px solid #3b82f6;

  border-radius: 12px;

  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.04);

  box-sizing: border-box;
}

.notice-content {
  min-width: 0;
}

.notice-content strong {
  display: block;

  margin-bottom: 2px;

  color: #374151;

  font-size: 12px;
}

.notice-content ul {
  margin: 0;
  padding-left: 15px;

  font-size: 0.9rem;

  line-height: 1.5;
}

.notice-content li {
  padding-left: 2px;
}

/* =========================================================
   입력 카드
========================================================= */

.form-section {
  overflow: hidden;

  background: #ffffff;

  border: 1px solid #e5e7eb;

  border-radius: 14px;

  box-shadow: 0 4px 15px rgba(15, 23, 42, 0.05);
}

/* =========================================================
   섹션 헤더
========================================================= */

.section-header {
  display: flex;

  align-items: center;
  justify-content: space-between;

  padding: 3px 15px;

  border-bottom: 1px solid #eef0f3;
}

.section-header h2 {
  margin: 2px 0 0;

  color: #111827;

  font-size: 1rem;
  font-weight: 700;
}

.section-header p {
  margin: 2px 0 0;

  color: #9ca3af;

  font-size: 11px;
}

/* 연도 */

.year-badge {
  display: flex;

  align-items: center;
  justify-content: center;

  min-width: 48px;
  height: 30px;

  padding: 0 10px;

  background: #f8fafc;

  border: 1px solid #e5e7eb;

  border-radius: 7px;

  color: #2563eb;

  font-size: 12px;
  font-weight: 700;
}

/* =========================================================
   테이블
========================================================= */

.table-wrapper {
  width: 100%;

  overflow-x: auto;

  padding: 3px;

  box-sizing: border-box;
}

.plan-table {
  width: 100%;

  border-collapse: separate;
  border-spacing: 0;

  border: 1px solid #e5e7eb;

  border-radius: 8px;

  overflow: hidden;
}

/* =========================================================
   테이블 헤더
========================================================= */

.plan-table th {
  min-height: 24px;

  padding: 2px 4px;

  background: #f8fafc;

  border-right: 1px solid #e5e7eb;
  border-bottom: 1px solid #dfe3e8;

  color: #374151;
  background:#f3f3f3;

  font-size: 12px;
  font-weight: 600;

  text-align: center;

  line-height: 1.35;

  box-sizing: border-box;
}

.plan-table th:last-child {
  border-right: 0;
}

.plan-table th.wide-col {
  min-width: 460px;
}

.plan-table th.narrow-col {
  min-width: 80px;
}

.plan-table th.month-col {
  min-width: 55px;
}

/* =========================================================
   테이블 본문
========================================================= */

.plan-table td {

  padding: 2px 2px;

  background: #ffffff;

  border-right: 1px solid #eef0f3;
  border-bottom: 1px solid #eef0f3;

  text-align: center;

  box-sizing: border-box;

  transition: background 0.15s;
}

.plan-table td:last-child {
  border-right: 0;
}

.plan-table tbody tr:last-child td {
  border-bottom: 0;
}

.plan-table tbody tr:hover td {
  background: #f8fafc;
}

/* =========================================================
   월 컬럼
========================================================= */

.month-cell {
  width: 30px;

  background: #f8fafc !important;

  color: #475569;

  font-weight: 700;

  font-size: 0.8rem;
}

.plan-table tbody tr:hover .month-cell {
  background: #eff6ff !important;

  color: #2563eb;
}

/* =========================================================
   입력
========================================================= */

.plan-table input {
  width: 100%;
  height: 24px;

  padding: 0 7px;

  background: #ffffff;

  border: 1px solid transparent;
  border-radius: 5px;

  outline: none;

  color: #374151;

  font-family: inherit;
  font-size: 0.8rem;

  box-sizing: border-box;

  transition: all 0.18s;
}

.plan-table input:hover {
  border-color: #e5e7eb;
  background: #fafafa;
}

.plan-table input:focus {
  border-color: #3b82f6;

  background: #ffffff;

  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

/* 가운데 입력 */

.center-input {
  text-align: center;
}

/* 일반 텍스트 */

.text-input {
  text-align: left;
}

/* 날짜 */

.date-input {
  text-align: center;

  font-size: 0.8rem !important;
}

/* Placeholder */

.plan-table input::placeholder,
.plan-table textarea::placeholder {
  color: #c0c7d0;
}

.plan-table textarea {
  width: 100%;
  height: 36px;
  min-height: 24px;
  padding: 2px 5px;
  resize: vertical;
  border: 1px solid transparent;
  border-radius: 5px;
  outline: none;
  font-family: inherit;
  font-size: 0.8rem;
  box-sizing: border-box;
}

.plan-table textarea:hover {
  border-color: #e5e7eb;
  background: #fafafa;
}

.plan-table textarea:focus {
  border-color: #3b82f6;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.text-area {
  text-align: left;
}

.delete-btn {
  background-color: #ef4444; /* 빨간색 */
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background 0.2s ease;
}

.delete-btn:hover {
  background-color: #dc2626; /* hover 시 더 진한 빨강 */
}

.delete-btn:active {
  background-color: #b91c1c; /* 클릭 시 눌린 효과 */
}
/* =========================================================
   하단
========================================================= */

.form-footer {
  display: flex;

  align-items: center;
  justify-content: space-between;

  padding: 3px 6px;

  background: #f8fafc;

  border-top: 1px solid #eef0f3;

  border-radius: 8px;

  box-sizing: border-box;
}

/* 안내 */

.save-guide {
  display: flex;

  align-items: center;

  gap: 6px;

  color: #94a3b8;

  font-size: 10px;
}

.guide-icon {
  display: inline-flex;

  align-items: center;
  justify-content: center;

  width: 16px;
  height: 16px;

  border-radius: 50%;

  background: #dcfce7;

  color: #16a34a;

  font-size: 9px;
  font-weight: 700;
}

/* =========================================================
   저장 버튼
========================================================= */

.save-btn {
  display: inline-flex;

  align-items: center;
  justify-content: center;

  gap: 6px;

  min-width: 95px;
  height: 36px;

  padding: 0 16px;

  background: #2563eb;

  border: 0;
  border-radius: 7px;

  color: #ffffff;

  font-family: inherit;

  font-size: 12px;
  font-weight: 600;

  cursor: pointer;

  box-shadow: 0 3px 7px rgba(37, 99, 235, 0.2);

  transition: all 0.2s;
}

.save-btn:hover {
  background: #1d4ed8;

  transform: translateY(-1px);

  box-shadow: 0 5px 12px rgba(37, 99, 235, 0.25);
}

.save-btn:active {
  transform: translateY(0);
}

/* =========================================================
   반응형
========================================================= */

@media (max-width: 1025px) {
  .page-header {
    flex-wrap: wrap;
  }

  .shop-selector,
  .owner-info {
    margin-left: 0;
  }
}

</style>
